import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"

export default function BoxedFacet({ facet }) {
    const { toggleProductFilter } = useFacet(facet);

    return (
        <div className="p-0 m-0">
            <div className="text-sm text-grey-3" data-nosto-element="facet">
                {facet.name}
            </div>    
            <ul className="list-none grid grid-cols-3 gap-x-3 gap-y-4 m-0 p-0 mt-4">
                {facet.data?.map(value => (
                    <li
                        className="p-0 m-0"
                        data-nosto-element="facet-setting"
                    >
                        <label 
                            className={`ns-facet__boxed-filter button button--small button--secondary-dark w-full !text-xs hover:!bg-transparent hover:!text-black !rounded cursor-pointer ${value.selected ? '!border-black' : '!border-grey-2'}`}
                        >
                            {value.value}
                            <input 
                                className="sr-only visually-hidden"
                                type="checkbox"
                                checked={value.selected} 
                                onChange={(e) => {
                                    e.preventDefault();
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }} 
                            />
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    )
}
